import { serviceURL } from "../../utils/service-url";

export class ImagesService {
  async upload(
    file: Buffer | File,
    name: string,
    accessToken: string,
    contentType?: string,
    updateTrackingVersion = false,
  ): Promise<{ success: true; url: string } | { success: false; url: undefined }> {
    const resp = await fetch(
      `${serviceURL("images")}upload/${name}${updateTrackingVersion ? `?version=${Date.now()}` : ""}`,
      {
        method: "PUT",
        // @ts-expect-error think cloudflare is confusing the types of fetch
        body: file,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          ...(contentType ? { "Content-Type": contentType } : {}),
        },
      },
    );

    if (!resp.ok) {
      return { success: false, url: undefined };
    }

    const location = resp.headers.get("location");
    if (!location) {
      return { success: false, url: undefined };
    }

    return { success: true, url: location };
  }

  async generateDirectUploadURL(
    accessToken: string,
  ): Promise<
    | { success: true; data: { uploadURL: string; uid: string } }
    | { success: false; data: undefined }
  > {
    const resp = await fetch(`${serviceURL("images")}direct-upload-url`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!resp.ok) {
      return { success: false, data: undefined };
    }

    const json = (await resp.json()) as { result: { uploadURL: string; uid: string } };

    return { success: true, data: json.result };
  }

  getCloudflareStreamThumbnailUrl(uid: string): string {
    return `${serviceURL("images")}thumbnail/v/${uid}`;
  }

  getDHThumbnailUrl(thumbnailUrl: string | null): string | null {
    if (!thumbnailUrl) {
      return null;
    }

    const path = new URL(thumbnailUrl).pathname;
    return `${serviceURL("images")}thumbnail${path}`;
  }
}
